import { pickMetrics, pickPeriods } from "@/grid/config/catalog";
import type { DepartmentDefinition } from "@/grid/core/types";

const SDR_THRESHOLDS = { green: 99, yellow: 60 } as const;
const SDR_PERIOD_WEIGHTS = {
  wtd: 1,
  lastWeek: 1,
  mtd: 1.5,
} as const;

export const sdrDepartment: DepartmentDefinition = {
  id: "sdr",
  name: "SDR",
  gridLabel: "SDR Grid",
  metrics: pickMetrics("sequences", "calls", "meetings", "sqls").map((metric) => {
    if (metric.id === "calls") return { ...metric, weight: 0.5 };
    if (metric.id === "meetings") return { ...metric, weight: 1.5 };
    return metric;
  }),
  periods: pickPeriods("wtd", "lastWeek", "mtd"),
  thresholds: SDR_THRESHOLDS,
  showRanking: true,
  rankingCount: 2,
  periodWeights: SDR_PERIOD_WEIGHTS,
};
